const Project = () => {

    const projects = [
        {
          "company": "National Cybersecurity R&D Laboratory (NUS)",
          "title": "Annual Cybersecurity Exercises & Hackathons",
          "description": "Contribute scenario design, challenge content, and technical infrastructure for annual cybersecurity exercises and hackathons, spanning critical infrastructure themes, defensive forensics, and applied cryptography."
        },
        {
          "company": "Singapore Data Science Consortium & SIA-NUS Corporate Laboratory",
          "title": "Health Informatics & Research Platforms",
          "description": "Contributed full-stack development of web applications for health informatics and research platforms, integrating ReactJS and Python Flask with backend AI components for employee wellness, fatigue, and research workflows."
        },
        {
          "company": "ESRI Singapore",
          "title": "Port Operation Digital Twin",
          "description": "Co-engineered a high-performance 2D/3D map-based Digital Twin using ReactJS and TypeScript, improving stakeholder visibility and real-time operational decision-making for critical port logistics."
        },
        {
          "company": "ESRI Singapore",
          "title": "National Defence Personnel Tracking",
          "description": "Led full-stack development of a mobile application supporting 2,000+ personnel, enforcing rigorous OWASP-compliant security reviews to identify and mitigate 100% of high-risk vulnerabilities in a critical defence environment."
        },
        {
          "company": "ESRI Singapore",
          "title": "Emergency Response GIS Application",
          "description": "Advocated for robust network and security architecture, collaborating with diverse stakeholders to cut projected deployment delays by 80%."
        },
        {
          "company": "Various Startups",
          "title": "Fintech AML & KYC Platform and Cloud MVPs",
          "description": "Delivered secure, cloud-native full-stack web and mobile MVPs including a fintech platform for AML & KYC (Django, JavaScript, third-party APIs), with ISO 27001-aligned practices and cloud architecture optimisations for large-scale data processing."
        }
    ];

    return (
        <div className="container-fluid main-content">
            <article className="about mt-4">
                <h1>Selected Projects</h1>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {projects.map((project, num) =>
                        <tr key={num}>
                            <th scope="row">{num+1}</th>
                            <td>
                                <span className="fw-bold">{project.title} | <span className="fst-italic">{project.company}</span></span>
                                <br />{project.description}
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
               <p className="lead text-center">Additional projects and details available upon request.</p>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
            </article>
        </div>
    );
};

export default Project;
